import { Checkbox } from '@mairistem/composants';
import React from 'react';

interface CustomCheckboxProps {
  libelle?: string;
}

const CustomCheckbox = ({
  libelle = null,
  ...rest
}: CustomCheckboxProps) => (
  <Checkbox
    {...rest}
    label={libelle}
  />
);

CustomCheckbox.defaultProps = {
  libelle: null,
};

export default CustomCheckbox;
